import './AppTeaser.css';
import Footer from './Footer';
import RegisterForm from './RegisterForm';
import cornwall from '../assets/backgrounds/corn-wall.jpg';
import handsWithTomato from '../assets/cutouts/hands-with-tomato.png';
import tomato from '../assets/cutouts/tomato-slice-01.png';
import painter from '../assets/cutouts/painter.png';
import droplet from '../assets/cutouts/green-droplet.png';
import spoon from '../assets/cutouts/spoon.png';
import soupBowl from '../assets/cutouts/soup-bowl.png';
import paper from '../assets/paper/paper.png';
import crumpled_paper_texture from '../assets/paper/crumpled-paper-texture.png'

function AppTeaser() {
  return (
    <section className="AppTeaser">
      <img className="AppTeaser-paper" src={paper} alt="" />
      <img className="AppTeaser-brick AppTeaser-brick--1" src={cornwall} alt="" />
      {/* 
      <img className="AppTeaser-brick AppTeaser-brick--2" src={cornwall} alt="" />
      <img className="AppTeaser-brick AppTeaser-brick--3" src={cornwall} alt="" />
      */}
      
      <div className="AppTeaser-leftPage">
        <img className="AppTeaser-hands" src={handsWithTomato} alt="" />
        <img className="AppTeaser-tomato AppTeaser-tomato--1" src={tomato} alt="" />
        <img className="AppTeaser-tomato AppTeaser-tomato--2" src={tomato} alt="" />
        <img className="AppTeaser-tomato AppTeaser-tomato--3" src={tomato} alt="" />
        

        <svg className="AppTeaser-comingSoon" height="1000" width="2000" xmlns="http://www.w3.org/2000/svg">
          <path id="soon-line" d="M 50 150 Q 200 -50 350 150" fill="none" />
          <text>
            <textPath href="#soon-line" x="185" y="70" startOffset="180" textAnchor="middle">Coming Soon</textPath>
          </text>
        </svg>
        <svg className='AppTeaser-IV' viewBox="0 0 435 449" xmlns="http://www.w3.org/2000/svg">
          <path id="iv-line" d="M 70 150 Q 200 -50 330 150" fill="none" />
          <text>
            <textPath href="#iv-line" x="185" y="70" startOffset="165" textAnchor="middle">Insane Vegan</textPath>
          </text>
        </svg>
        <svg className="AppTeaser-App" viewBox="0 0 435 449" xmlns="http://www.w3.org/2000/svg">
          <path id="app-line" d="M 50 170 Q 200 -30 350 170" fill="none" />
          <text>
            <textPath href="#app-line" x="185" y="70" startOffset="170" textAnchor="middle">App</textPath>
          </text>
        </svg>
      </div>

      <div className="AppTeaser-rightPage">
        <img className="AppTeaser-droplet AppTeaser-droplet--1" src={droplet} alt="" />
        <img className="AppTeaser-droplet AppTeaser-droplet--3" src={droplet} alt="" />
        <img className="AppTeaser-droplet AppTeaser-droplet--4" src={droplet} alt="" />
        <img className="AppTeaser-droplet AppTeaser-droplet--2" src={droplet} alt="" />
        <p className="AppTeaser-viggie">Meet Viggie the Vegan</p>
        <p className="AppTeaser-connect">Connect with others</p>
        <p className="AppTeaser-scan">Scan foods, receive Insane Vegan Scores</p>
        <img className="AppTeaser-spoon" src={spoon} alt="" />
        <img className="AppTeaser-soup" src={soupBowl} alt="" />
      </div>
      

      <div className="AppTeaser-RegisterInterest">
        <img className="AppTeaser-painter" src={painter} alt="" />
        <img className="AppTeaser-InterestPaper" src={crumpled_paper_texture} alt="" />
        <h2 className="AppTeaser-Loop">STAY IN THE <span className="AppTeaser-GreenText">LOOP</span></h2>
        <p className="AppTeaser-InterestDescription">Join the Insane Vegan community and be the first 
          to hear about the app, updates, recipes, events, and more!
        </p>
        <RegisterForm />
      </div>


      <Footer />
    </section>
  );
}

export default AppTeaser;
